{
  "version": 1,
  "asset_id": "1da92aad-92e5-441e-bf8b-1dd55c7d3695",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/1da92aad-92e5-441e-bf8b-1dd55c7d3695/homosassa-blue-metal-roof-installation-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/1da92aad-92e5-441e-bf8b-1dd55c7d3695/homosassa-blue-metal-roof-installation-480w.avif",
  "original_filename": "homosassa-blue-metal-roof-installation-480w.avif",
  "size": 12901,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:42Z"
}
